import BaseModel from '../../base';

import constants from './constants';
import glossary from './glossary';

import User from '@/utils/user';

export default class Image extends BaseModel {
  #user;

  constructor(item = {}, url) {
    super(item, url);

    this.#user = new User();

    this.image = item.image || {
      is_main: false,
      thumb: '',
      url: '',
      owner_id: this.#user?.data?.id,
    };
    this.is_public = item.is_public || false;
    this.organizer_id = item.organizer_id;
    this.type = item.type;
  }

  get isOwner() {
    const { image } = this;
    return image?.owner_id === this.#user?.data?.id;
  }

  get displayType() {
    const { type } = this;
    return this.constructor.glossary.IMAGE_TYPES_DATA[type];
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
